import React from 'react'
import { useTranslation } from 'react-i18next'
import { CARD } from './ChatStatsSection'
import { formatNumber, formatPercent } from './chatStatsFormat'

function ChatStatsClasses({ stats }) {
    const { t } = useTranslation()
    const rows = stats.by_class
    const busiest = rows.reduce((max, row) => Math.max(max, row.count), 0)

    return (
        <div style={{ ...CARD, padding: '22px 24px', flex: 1, minWidth: 320 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                <span style={{ fontSize: 18, fontWeight: 700, color: '#2d2b45' }}>{t('chatStatsByClass')}</span>
                <span style={{ background: '#e4e3f0', color: '#5e639b', fontSize: 12, fontWeight: 700, padding: '3px 10px', borderRadius: 999 }}>
                    {t('chatStatsDaysBadge', { count: stats.period.days })}
                </span>
            </div>

            {rows.length === 0 ? (
                <div style={{ fontSize: 13, color: '#8e8fb4' }}>{t('chatStatsNoClassInfo')}</div>
            ) : (
                rows.map((row) => (
                    <div key={row.class_id} style={{ marginBottom: 14 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 7 }}>
                            <span style={{ flex: 1, fontSize: 14, fontWeight: 600, color: '#5e639b' }}>{row.label || t('chatStatsUnnamedClass')}</span>
                            <span style={{ fontSize: 13, fontWeight: 700, color: '#2d2b45' }}>
                                {formatNumber(row.count)} · {formatPercent(row.percent)}
                            </span>
                        </div>
                        <div style={{ height: 12, background: '#e4e3f0', borderRadius: 999, overflow: 'hidden' }}>
                            <div style={{ height: '100%', width: `${busiest ? (row.count / busiest) * 100 : 0}%`, background: '#5e639b', borderRadius: 999 }} />
                        </div>
                    </div>
                ))
            )}
        </div>
    )
}

export default ChatStatsClasses
